<script lang="ts">
    import AppLogoIcon from '@/components/AppLogoIcon.svelte';
</script>

<div class="inline-flex items-center gap-3">
    <div class="flex shrink-0 items-center justify-center rounded-md pr-4">
        <img src="/culmex-logo.svg" alt="Logo" class="h-16 w-44" />
    </div>
<!--    <div class="flex items-center">-->
<!--        <span class="truncate text-sm font-semibold">Laravel Starter Kit</span>-->
<!--    </div>-->
</div>
